<template>
  <file-table 
    :foldName="'report6'"
    :authority="'AssetReport'">
  </file-table>
</template>

<script>
import tableFileDownLoad from "../../components/content/maintabber/TableFileDownLoad";
export default {
  name:"index",
  components:{
    "file-table": tableFileDownLoad,
  },
  data(){
    return{

    }
  }
}
</script>

<style>

</style>